module.exports = __webpack_public_path__ + "img/service.b6955a2e.svg";